import { Participant } from '../models';
import { ParticipantRepository, TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';
import { ABSOLUTE_MAX_PARTICIPANTS } from '../models/PlanLimits';

export class AddRegisteredParticipantUseCase {
  constructor(
    private participantRepository: ParticipantRepository,
    private tournamentRepository: TournamentRepository
  ) {}

  async execute(params: {
    tournamentId: string;
    userId: string;
    userName: string;
  }): Promise<Participant> {
    const { tournamentId, userId, userName } = params;

    logger.debug('AddRegisteredParticipant', 'Adding participant', { tournamentId, userId });

    // Verificar que el torneo existe
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    if (tournament.status !== 'setup') {
      throw new Error('Cannot add participants after tournament has started');
    }

    // Verificar que el usuario no esté ya como participante
    const existingParticipants = await this.participantRepository.getByTournamentId(tournamentId);
    const isAlreadyParticipant = existingParticipants.some(p => p.userId === userId);

    if (isAlreadyParticipant) {
      throw new Error('User is already a participant in this tournament');
    }

    // Check participant limits
    if (tournament.maxParticipants && existingParticipants.length >= tournament.maxParticipants) {
      throw new Error('Tournament is full');
    }
    if (existingParticipants.length >= ABSOLUTE_MAX_PARTICIPANTS) {
      throw new Error('Tournament has reached the maximum allowed participants');
    }

    // Calcular el seed
    const seed = existingParticipants.length + 1;

    // Añadir participante
    const participant = await this.participantRepository.create({
      tournamentId,
      name: userName,
      seed,
      userId, // ← Vincular al usuario
    });

    logger.debug('AddRegisteredParticipant', 'Participant added', { participantId: participant.id });

    return participant;
  }
}